import React, { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { addHours, format } from "date-fns";

import { formatCurrency } from "../utils/FormatCurrency";
import iconWhats from "../assets/icon-whats.png";

export function ProtestadoDialog({ close, tableData }) {
  // useEffect(() => { console.log('Protesto Info', tableData) }, [tableData])
  return (
    <div className="boletosDialog">
      <Dialog
        visible
        className="boletosDialog w-[100%] sm:w-4/5 lg:w-4/5 h-auto text-center protestoCustom"
        onHide={() => close()}
        draggable={false}
        header={
          <div className="w-full h-full text-base">
            <div className="mb-3 mt-2">
              <h3>Atenção!!!</h3>
            </div>
            <p className="font-lato text-xl mt-2">
              <b>Você possui débitos protestados.</b>
            </p>
          </div>
        }
        footer={
          <div className="">
            <p className="text-black text-lg text-center">
              <b>Entre em contato para ter mais informações.</b>
            </p>
            <div className="flex justify-center gap-2 mt-2">
              <div className="flex text-center justify-center mt-2">
                <a
                  target="_blank"
                  style={{ color: "white" }}
                  href="https://wa.me/5511996383405?text=Oi"
                  rel="noreferrer"
                >
                  <div
                    className="flex px-5 py-1"
                    style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
                  >
                    <img
                      className="mx-2"
                      src={iconWhats}
                      alt="direto-logo"
                      style={{ height: "27px", width: "auto" }}
                    ></img>
                    <h6 className="font-lato text-md">Suporte Whatsapp 1</h6>
                  </div>
                </a>
              </div>
              <div className="flex text-center justify-center mt-2">
                <a
                  target="_blank"
                  style={{ color: "white" }}
                  href="https://wa.me/5511988812431?text=Oi"
                  rel="noreferrer"
                >
                  <div
                    className="flex px-5 py-1"
                    style={{ backgroundColor: "#25D366", borderRadius: 15, borderColor: "white" }}
                  >
                    <img
                      className="mx-2 "
                      src={iconWhats}
                      alt="direto-logo"
                      style={{ height: "27px", width: "auto" }}
                    ></img>
                    <h6 className="font-lato text-md">Suporte Whatsapp 2</h6>
                  </div>
                </a>
              </div>
            </div>
          </div>
        }
      >
        <div className="">
          {/* <p className="text-base">* A descrição não faz referência a data de quando a negociação de quitação de dívidas foi realizada.</p> */}
          <DataTable className="customTabelaProtesto" value={tableData} responsiveLayout="stack">
            <Column className="text-base bg-blue-200" header="Descrição Origem " field="cobranca_descricao" />
            <Column
              className="text-base bg-blue-200"
              header="Valor da cobrança original"
              field="cobranca_valor"
              body={(rowData) => formatCurrency(rowData.cobranca_valor)}
            />
            <Column
              className="text-base bg-green-300"
              header="Data de vencimento"
              field="data_vencimento_primeiro_boleto"
              body={(rowData) =>
                rowData.data_vencimento_primeiro_boleto
                  ? format(addHours(new Date(rowData.data_vencimento_primeiro_boleto), 3), "dd/MM/yyyy")
                  : "-"
              }
            />
            <Column
              className="text-base bg-yellow-200"
              header="Data de protesto"
              field="protesto_registro_envio"
              body={(rowData) =>
                rowData.protesto_registro_envio
                  ? format(addHours(new Date(rowData.protesto_registro_envio), 3), "dd/MM/yyyy")
                  : "Não registrado"
              }
            />
            <Column
              className="text-base bg-yellow-200"
              header="Valor enviado a protesto"
              field="protesto_divida_saldo"
              body={(rowData) => formatCurrency(rowData.protesto_divida_saldo)}
            />
            <Column className="text-base bg-yellow-200" header="Empresa" field="protesto_credor_nome" />
          </DataTable>
        </div>
      </Dialog>
    </div>
  );
}
